import { render } from "./SelecionarTipoPreco.vue?vue&type=template&id=7f6468fa&scoped=true&ts=true"
import script from "./SelecionarTipoPreco.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoPreco.vue?vue&type=script&lang=ts"

import "./SelecionarTipoPreco.vue?vue&type=style&index=0&id=7f6468fa&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6468fa"]])

export default __exports__